import React from "react";
import "./StatisticsTab.css";
import {ButtonGroup, Card, Col, Container, Row, Table, ToggleButton} from "react-bootstrap";
import PaginationTable from "../../../../../components/paginationTable/PaginationTable";
import { withTranslation } from "react-i18next";
import { ResponsivePie } from "@nivo/pie";
import CamplaCoreService from "../../../../../services/CamplaCoreService";
import {
  faArchive,
  faDatabase,
  faDesktop,
  faFileContract,
  faFileSignature, faFilter,
  faVirus
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {textFilter} from "react-bootstrap-table2-filter";
import StorageService from "../../../../../services/StorageService";
import PaginationTableFilterToggle
  from "../../../../../components/paginationTableFilterToggle/PaginationTableFilterToggle";

class StatisticsTab extends React.Component {
  constructor(props) {
    super(props);
    this.tableId = "HardwareProducts";
    this.state = {
      colors: ["#54BF8D", "#ce6060", "#5a82a9", "#18181e", "#d89109"],
      cloudConnector: {
        examinationsCount: -1,
        examinationStatus: null,
        totalInstances: -1
      },
      platformStorage: {
        totalStorageSize: -1,
        virusDetectionCount: -1,
        archivedInstanceStoragesCount: -1
      },
      hardware: {
        resolutions: null,
        products: null,
        tpmVersion: null
      },
      showFilters: true
    };

    this.loadData = this.loadData.bind(this);
    this.pieChart = this.pieChart.bind(this);
    this.dataTable = this.dataTable.bind(this);
    this.humanReadableFileSize = this.humanReadableFileSize.bind(this);
  }

  componentDidMount() {
    this.loadData();
  }

  humanReadableFileSize(size) {
    const labels = ["B", "KB", "MB", "GB", "TB"];
    let ct = 0;
    while (size > 1024 && ct < labels.length) {
      size /= 1024;
      ct++;
    }
    return `${Math.round(size * 100) / 100} ${labels[ct]}`;
  }

  async loadData() {
    const statistics = await CamplaCoreService.getAllStatistics();
    const examinationStatus =
      typeof statistics["cloudConnector"] !== "undefined"
        ? {
          ready: {label: "Dashboard.AdminDashboard.StatisticsTab.StatusReady", value: statistics.cloudConnector.readyCount},
          open: {label: "Dashboard.AdminDashboard.StatisticsTab.StatusOpen", value: statistics.cloudConnector.openCount},
          closed: {label: "Dashboard.AdminDashboard.StatisticsTab.StatusClosed", value: statistics.cloudConnector.closedCount},
          paused: {label: "Dashboard.AdminDashboard.StatisticsTab.StatusPaused", value: statistics.cloudConnector.pausedCount},
          inProgress: {label: "Dashboard.AdminDashboard.StatisticsTab.StatusInProgress", value: statistics.cloudConnector.inProgressCount}
        }
        : null;
    const cloudConnector =
      typeof statistics.cloudConnector !== "undefined"
        ? {
          examinationStatus: examinationStatus,
          totalInstances: statistics.cloudConnector.totalInstances,
          examinationsCount: statistics.cloudConnector.examinationsCount
        }
        : {
          examinationStatus: examinationStatus,
          totalInstances: -1,
          examinationsCount: -1
        };
    const platformStorage =
      typeof statistics.platformStorage !== "undefined"
        ? {
          totalStorageSize: statistics.platformStorage.totalStorageSize,
          archivedInstanceStoragesCount:
          statistics.platformStorage.archivedInstanceStoragesCount,
          virusDetectionCount:
            typeof statistics.platformStorage.connectorStatistic
              .virusDetectionCount !== "undefined"
              ? statistics.platformStorage.connectorStatistic
                .virusDetectionCount
              : -1
        }
        : {
          totalStorageSize: -1,
          archivedInstanceStoragesCount: -1,
          virusDetectionCount: -1
        };
    const hardware =
      typeof statistics.general["hardware"] !== "undefined"
        ? {
          resolutions:
            Object.keys(statistics.general["hardware"].resolutions).length > 0
              ? statistics.general["hardware"].resolutions
              : null,
          products: statistics.general["hardware"].products,
          tpmVersion:
            Object.keys(statistics.general["hardware"].tpm.version).length > 0
              ? statistics.general["hardware"].tpm.version
              : null
        }
        : {
          resolutions: null,
          products: {},
          tpmVersion: null
        };
    this.setState({
      cloudConnector: cloudConnector,
      platformStorage: platformStorage,
      hardware: hardware
    });
  }

  dataTable(rawData, t) {
    const buildColumn = () => [
      {
        dataField: "product",
        text: t("Dashboard.AdminDashboard.StatisticsTab.ColumnProduct"),
        filter: textFilter({
          placeholder: t("Dashboard.AdminDashboard.StatisticsTab.ColumnProductPlaceholder"),
          style: { display: this.state.displayFilter }
        }),
        sort: true
      },
      {
        dataField: "tpmVersion",
        text: t("Dashboard.AdminDashboard.StatisticsTab.ColumnTPMVersion"),
        filter: textFilter({
          placeholder: t("Dashboard.AdminDashboard.StatisticsTab.ColumnTPMVersionPlaceholder"),
          style: { display: this.state.displayFilter }
        }),
        sort: true
      },
      {
        dataField: "count",
        text: t("Dashboard.AdminDashboard.StatisticsTab.ColumnCount"),
        sort: true
      },
      {
        dataField: "actions",
        text: "",
        headerFormatter: () => (
            <PaginationTableFilterToggle
                onFilterToggle={(e) => {
                  this.setState({
                    showFilters: e.currentTarget.checked,
                    displayFilter: e.currentTarget.checked ? "initial" : "none",
                  });
                }}
                showFilters={this.state.showFilters}
                tableId={this.tableId} />
        ),
        headerClasses: "actionHeader",
        isDummyField: true,
        csvExport: false,
        formatter: () => <div></div>
      }
    ];
    const data = [];
    for (const label in rawData) {
      const versions = rawData[label].tpm.map(tp => tp.version);
      data.push({
        product: label,
        tpmVersion: [...new Set(versions)].join(";"),
        count: rawData[label].count
      });
    }
    data.sort((a, b) => b.count - a.count);
    return (
      <PaginationTable
        data={data}
        sizePerPage={10}
        paginationSize={3}
        columns={buildColumn()}
        keyField="product"
        id="adminDashboardTable"
      />
    );
  }

  pieChart(rawData, t) {
    if (!rawData) {
      return <b>No data yet</b>;
    }
    let data = [];
    for (const label in rawData) {
      if (typeof rawData[label] === "object"){
        if (rawData[label].value > 0){
          data.push({
            id: t(rawData[label].label),
            label: t(rawData[label].label),
            value: rawData[label].value
          });
        }
      }else{
        if (rawData[label] > 0){
          data.push({
            id: label,
            label: label,
            value: rawData[label]
          });
        }
      }
    }
    data.sort((a, b) => b.value - a.value);
    if (data.length > 5) {
      const newData = [];
      let others = 0;
      for (let i = 0; i < data.length; i++) {
        if (i < 4) {
          newData.push(data[i]);
        } else {
          others += data[i].value;
        }
      }
      newData.push({
        id: "others",
        label: "others",
        value: others
      });
      data = newData;
    }
    return (
      <ResponsivePie
        data={data}
        margin={{ top: 40, right: 80, bottom: 80, left: 80 }}
        innerRadius={0.5}
        padAngle={0.7}
        cornerRadius={3}
        colors={this.state.colors}
        borderWidth={1}
        borderColor={{ from: "color", modifiers: [["darker", 0.2]] }}
        radialLabelsSkipAngle={10}
        radialLabelsTextColor="#333333"
        radialLabelsLinkColor={{ from: "color" }}
        sliceLabelsSkipAngle={10}
        sliceLabelsTextColor="#333333"
        defs={[
          {
            id: "dots",
            type: "patternDots",
            background: "inherit",
            color: "rgba(255, 255, 255, 0.3)",
            size: 4,
            padding: 1,
            stagger: true
          },
          {
            id: "lines",
            type: "patternLines",
            background: "inherit",
            color: "rgba(255, 255, 255, 0.3)",
            rotation: -45,
            lineWidth: 6,
            spacing: 10
          }
        ]}
        legends={[
          {
            anchor: "right",
            direction: "column",
            justify: false,
            translateX: 75,
            translateY: 120,
            itemsSpacing: 2,
            itemWidth: 75,
            itemHeight: 18,
            itemTextColor: "#999",
            itemDirection: "left-to-right",
            itemOpacity: 1,
            symbolSize: 18,
            symbolShape: "circle",
            effects: [
              {
                on: "hover",
                style: {
                  itemTextColor: "#000"
                }
              }
            ]
          }
        ]}
      />
    );
  }

  render(){
    const {t} = this.props;
    return (
        <Container className="ml-0 mr-0 pl-0 pr-0 pt-3">
          <Row>
            <Col sm={8}>
              <Card className="dashboard-panel">
                <Card.Header>{t("Dashboard.AdminDashboard.StatisticsTab.CardTitleActiveResources")}</Card.Header>
                <Card.Body>
                  <Table>
                    <tr>
                      <td>
                        <FontAwesomeIcon
                            icon={faFileSignature}
                            className="color-green"
                        />
                      </td>
                      <td>{t("Dashboard.AdminDashboard.StatisticsTab.OpenExaminations")}</td>
                      <td>
                        <b>
                          {this.state.cloudConnector.examinationStatus
                              ? this.state.cloudConnector.examinationStatus.open.value
                              : "-"}
                        </b>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <FontAwesomeIcon
                            icon={faFileContract}
                            className="color-green"
                        />
                      </td>
                      <td>{t("Dashboard.AdminDashboard.StatisticsTab.TotalExaminations")}</td>
                      <td>
                        <b>
                          {this.state.cloudConnector.examinationsCount > -1
                              ? this.state.cloudConnector.examinationsCount
                              : "-"}
                        </b>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <FontAwesomeIcon
                            icon={faDesktop}
                            className="color-green"
                        />
                      </td>
                      <td>{t("Dashboard.AdminDashboard.StatisticsTab.Instances")}</td>
                      <td>
                        <b>
                          {this.state.cloudConnector.totalInstances > -1
                              ? this.state.cloudConnector.totalInstances
                              : "-"}
                        </b>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <FontAwesomeIcon
                            icon={faDatabase}
                            className="color-green"
                        />
                      </td>
                      <td>{t("Dashboard.AdminDashboard.StatisticsTab.UsedStorage")}</td>
                      <td>
                        <b>
                          {this.state.platformStorage.totalStorageSize > -1
                              ? this.humanReadableFileSize(
                                  this.state.platformStorage.totalStorageSize
                              )
                              : "-"}
                        </b>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <FontAwesomeIcon icon={faVirus} className="color-green" />
                      </td>
                      <td>{t("Dashboard.AdminDashboard.StatisticsTab.TotalMalwareDetections")}</td>
                      <td>
                        <b>
                          {this.state.platformStorage.virusDetectionCount > -1
                              ? this.state.platformStorage.virusDetectionCount
                              : "-"}
                        </b>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <FontAwesomeIcon
                            icon={faArchive}
                            className="color-green"
                        />
                      </td>
                      <td>{t("Dashboard.AdminDashboard.StatisticsTab.ArchivedStorages")}</td>
                      <td>
                        <b>
                          {this.state.platformStorage
                              .archivedInstanceStoragesCount > -1
                              ? this.state.platformStorage
                                  .archivedInstanceStoragesCount
                              : "-"}
                        </b>
                      </td>
                    </tr>
                  </Table>
                </Card.Body>
              </Card>
            </Col>
            <Col sm={4}>
              <Card className="dashboard-panel">
                <Card.Header>{t("Dashboard.AdminDashboard.StatisticsTab.CardTitleExaminationStatus")}</Card.Header>
                <Card.Body>
                  <div style={{ height: 311 }}>
                    {this.pieChart(this.state.cloudConnector.examinationStatus, t)}
                  </div>
                </Card.Body>
              </Card>
            </Col>
          </Row>
          <Row className="mt-3">
            <Col sm={6}>
              <Card className="dashboard-panel">
                <Card.Header>{t("Dashboard.AdminDashboard.StatisticsTab.CardTitleTPMVersions")}</Card.Header>
                <Card.Body>
                  <div style={{ height: 300 }}>
                    {this.pieChart(this.state.hardware.tpmVersion, t)}
                  </div>
                </Card.Body>
              </Card>
            </Col>
            <Col sm={6}>
              <Card className="dashboard-panel">
                <Card.Header>{t("Dashboard.AdminDashboard.StatisticsTab.CardTitleDisplayResolutions")}</Card.Header>
                <Card.Body>
                  <div style={{ height: 300 }}>
                    {this.pieChart(this.state.hardware.resolutions, t)}
                  </div>
                </Card.Body>
              </Card>
            </Col>
          </Row>
          <Row className="mt-3">
            <Col>
              <Card className="dashboard-panel">
                <Card.Header>{t("Dashboard.AdminDashboard.StatisticsTab.CardTitleProducts")}</Card.Header>
                <Card.Body>
                  {this.dataTable(this.state.hardware.products, t)}
                </Card.Body>
              </Card>
            </Col>
          </Row>
        </Container>
    );
  }
}

export default withTranslation()(StatisticsTab);
